// Encrypt function
export const encryptData = (data, stringify = false) => {
    try {
        if (stringify) {
            data = JSON.stringify(data);
        }

        if (process.env.NODE_ENV === 'development') {
            // In development, just return the JSON stringified data
            return data;
        } else if (process.env.NODE_ENV === 'production') {
            // In production, encrypt the data
            return data;
            // return JSON.stringify(data)
        } else {
            console.warn('NODE_ENV is not set correctly. Defaulting to JSON.stringify.');
            return data;
            // return JSON.stringify(data)
        }
    } catch (error) {
        console.error(error);

        return null;
    }
};

// Decrypt function
export const decryptData = (data, stringify = false) => {
    try {
        if (stringify && typeof data === 'string') {
            data = JSON.parse(data);
        }

        if (process.env.NODE_ENV === 'development') {
            return data;
        } else if (process.env.NODE_ENV === 'production') {
            return data;
        } else {
            console.warn('NODE_ENV is not set correctly. Returning raw value.');
            return data;
        }
    } catch (error) {
        console.error('DecryptData error:', error, '\nRaw data:', data);
        return null;
    }
};
